import styles from '../../components/Home/home.module.scss';
import {useCallback, useEffect, useMemo, useRef, useState} from "react";
import dynamic from "next/dynamic";
import SortBy from "@/components/SoryBy";
import {APIGetGuideFinish, APIGetHomeBannerClick, APIGetProductList} from "@/api";
import SizeBox from "@/components/SizeBox";
import {Carousel, Spin, Tour} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import CategoryTreeSelect from "@/components/TreeSelect";
import CustomEmpty from '@/components/CustomEmpty';
import { useRouter } from "next/router";
import ProductCard from "@/components/ProductCard";
import SelectComp from "@/components/SelectComp";
import Masonry from "react-masonry-css";
import CommonLoading from "@/components/CommonLoading";
import { generateRandomStringWithTimestamp } from "@/utils/utils";
import TourModal from "@/components/TourModal";
import { useSelector } from "react-redux";
import gaTracker from "@/ga";
import Image from "next/image";
import eventSub, {EventName} from "@/common/EventSub";
import { debounce } from 'lodash';
import HotProductWrap from "@/components/HotProductWrap";
import CategorySelectModal from "@/components/CategorySelectModal";
import useLogin from "@/hooks/useLogin";
import { useTranslation } from "react-i18next";
import useLanguage from "@/hooks/useLanguage";
import AppImage from "@/components/AppImage";
import useHomeBanner from "@/hooks/useHomeBanner";
import Skeleton from "@/components/Skeleton";
const SearchBar = dynamic(() => import("@/components/SearchBar"), {
  ssr: false, // 如果组件只在客户端渲染，可以设置为 false
  loading: () => <></>, // 可选：提供一个加载状态
});
let data = [];
let category1IdRef;
let pageRef = 1;

const Home = () => {
  const [prodList, setProdList] = useState([]);
  const [sort, setSort] = useState(5);
  const sortRef = useRef(5);
  const [sortType, setSortType] = useState();
  let category1IdRef = useRef(null);
  const [category1Id, setCategory1Id] = useState(category1IdRef.current);

  const [page, setPage] = useState(pageRef);

  const [commissionType, setCommissionType] = useState([]);
  const commissionTypeRef = useRef([]);
  const [earnPerType, setEarnPerType] = useState([]);
  const earnPerTypeRef = useRef([]);

  const [productTags, setProductTags] = useState([]);
  const productTagsRef = useRef([]);

  const [productRates, setProductRates] = useState([]);
  const productRatesRef = useRef([]);

  const [visibleDropDown, setVisibleDropDown] = useState(false);
  const [loading, setLoading] = useState(false);
  const loadingRef = useRef();
  const [pageLoading, setPageLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [random, setRandom] = useState(1);
  const [categrayState, setCategrayState] = useState(1);
  const [hasMore, setHasMore] = useState(true); // 记录是否还有更多数据
  const [isGetList, setIsGetList] = useState(false); // 是否获取数据
  const userInfo = useSelector(state => state.home.userInfo.userInfo);
  const scrollDiv = useRef();
  const searchNameRef = useRef();
  const searchNameTypeRef = useRef(2);
  const [currentExt, setCurrentExt] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [freeSample, setFreeSample] = useState(false);
  const freeSampleRef = useRef(0);
  const [selectedTag, setSelectedTag] = useState();
  const {bannerList} = useHomeBanner();
  const router = useRouter();

  const [open, setOpen] = useState(false);

  const [currentStep, setCurrentStep] = useState(0);

  const stepRef1 = useRef(null);
  const stepRef2 = useRef(null);
  const { getUserInfo } = useLogin();

  const [needClickMore, setNeedClickMore] = useState(false);

  const headerWrapRef = useRef(null);

  const { t, unit, changeLanguageWithoutReload } = useLanguage();

  useEffect(() => {
    headerWrapRef.current = document.getElementById("header_anystarr_wrap");
  }, []);


  useEffect(() => {
    if (open) {
      // 锁定 body 防止滚动条出现/消失引起 Tour 位置变化
      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollBarWidth}px`; // 补偿滚动条占用的宽度
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  }, [open, currentStep]);

  const openCategoryModal = () =>{
    setSelectedTag(true);
  };

  const skipTour = () =>{
    setOpen(false);
    openCategoryModal();
  };


  const steps = [
    {
      description: <TourModal
        des={<div>
          <span className={"text-[#FF6E1F] font-bold"}> {t('home.tour.find_products')}  </span> by using recommendation button, search, filter, sort functions.
        </div>}
        index={1} next={() => setCurrentStep(currentStep + 1)} skip={skipTour} />,
      target: () => stepRef1.current,
      nextButtonProps: null,
      prevButtonProps: null,
    },
    {
      description: <TourModal
        lineClassName={"rotate-[-90deg]"}
        wrapLintClassName={"!left-[-340px] !top-[-45px]"}
        des={<div>
          <div className={"flex items-start"}>
            <div className={"w-[5px] h-[5px] mt-[10px] bg-[#222] rounded-full mr-[5px] shrink-0"}></div>
            <div className={"flex flex-wrap"}>
              {t('home.tour.click_card')} <span className={"text-[#FF6E1F] font-bold"}> {" "} {t('home.tour.product_details')}  </span>.
            </div>
          </div>
          <div className={" flex items-start"}>
            <div className={"w-[5px] h-[5px] mt-[10px] bg-[#222] rounded-full mr-[5px] shrink-0"}></div>
            <div className={"flex flex-wrap"}>
              {t('home.tour.click_the')} "<span className={"text-[#FF6E1F] font-bold"}> {t('home.tour.add_to_showcase')} </span>" {t('home.tour.add_products')}.
            </div>
          </div>
          <div className={"flex items-start"}>
            <div className={"w-[5px] h-[5px] mt-[10px] bg-[#222] rounded-full mr-[5px] shrink-0"}></div>
            <div className={"flex flex-wrap"}>
              {t('home.tour.click_the')} "<span className={"text-[#FF6E1F] font-bold"}> {t('home.tour.sample')} </span>" {t('home.tour.request_sample')}.
            </div>
          </div>
          <div className={"flex items-start"}>
            <div className={"w-[5px] h-[5px] mt-[10px] bg-[#222] rounded-full mr-[5px] shrink-0"}></div>
            <div className={"flex flex-wrap"}>
              {t('home.tour.light_stars')} {" "} <span className={"text-[#FF6E1F] font-bold ml-1"}> {t('home.tour.collection')} </span> , and then "{t('home.tour.batch_add')}"!
            </div>
          </div>
        </div>}
        className={"mr-[120px]"} index={2} next={() => setCurrentStep(currentStep + 1)} pre={() => setCurrentStep(currentStep - 1)} skip={skipTour} />,
      target: () => stepRef2.current,
      placement: "right",
      nextButtonProps: null,
      prevButtonProps: null,
    },
    {
      description: <TourModal des={
        <div>
          {t('home.tour.click_here')} <span className={"text-[#FF6E1F] font-bold"}> {t('home.tour.earnings_analysis')} </span> , <span className={"text-[#FF6E1F] font-bold"}> {t('home.tour.showcase_products')} </span> and <span className={"text-[#FF6E1F] font-bold"}> {t('home.tour.collection')} </span>.
          {t('home.tour.find_also')} <span className={"text-[#FF6E1F] font-bold"}> {t('home.tour.higher_commission')} </span> {t('home.tour.products_here')}.
        </div>
      } index={3} onEnd={skipTour} pre={() => setCurrentStep(currentStep - 1)} />,
      target: () => headerWrapRef.current,
      placement: "bottom",
      nextButtonProps: null,
      prevButtonProps: null,
    },
  ];


  const reqId = useRef(1);

  useEffect(() => {
    setLoaded(true);
  }, []);

  const getProdList = (searchNameRe, searchType, noSkipLoading = true) => {
    // setProdList(prodListMock);

    if (needClickMore) return;

    if (loadingRef.current && noSkipLoading) {
      return;
    }

    if (loading && noSkipLoading) return; // 检查是否正在加载或没有更多数据
    loadingRef.current = true;
    let nowPage = searchNameRe ? 1 : page;
    if (searchNameRe) {
      setLoading(true);
    } else if (page === 1) {
      setPageLoading(true);
    }
    setLoadingMore(true);

    const randomNum = localStorage.getItem("randomNum") ?? generateRandomStringWithTimestamp();
    if (!localStorage.getItem("randomNum")) {
      localStorage.setItem("randomNum", randomNum);
    }

    reqId.current = reqId.current + 1;
    let currentReqId = reqId.current;
    APIGetProductList(JSON.stringify({
      sort: sortRef.current,
      sortType: sortType,
      page: nowPage,
      pageSize: 40,
      categoryIds: getCategoryIds(category1IdRef.current),
      searchName: searchNameRef.current,
      // searchType: searchType,
      searchType: searchType ? searchType : searchNameTypeRef.current,
      commissionTypes: commissionTypeRef.current.join(","),
      earnPerTypes: earnPerTypeRef.current.join(","),
      productScores: productRatesRef.current.join(","),
      productTags: productTagsRef.current.join(","),
      freeSample:freeSampleRef.current,
      uuid: sortRef.current === 5 ? randomNum : undefined
    })).then(resp => {
      if (resp.data.list) {
        if (currentReqId === reqId.current) {
          if (nowPage === 1) {
            data = resp.data.list.records;
            setProdList([]);
            setProdList(data.slice());
          } else {
            // data = prodList.slice().concat(resp.data.list.records);
            data = resp.data.list.records;
            setProdList([...prodList, ...data]);
            setIsGetList(false);
          }

          if (nowPage % 6 === 0) {
            setNeedClickMore(true);
          }

        }
      }
      loadingRef.current = false;
    }).finally(() => {
      if (currentReqId === reqId.current) {
        setPageLoading(false);
      }
      setLoading(false);
      setIsGetList(false);
      setLoadingMore(false);
      loadingRef.current = false;
    }).catch(e => {
      setPageLoading(false);
      setLoading(false);
      setIsGetList(false);
      loadingRef.current = false;
    });
  };

  const getCategoryIds = (ids) => {
    if (ids) {
      return getLastElements(ids).join(",");
    }
    return null;
  };

  function getLastElements(arr) {
    const result = [];
    for (const subArray of arr) {
      if (subArray.length > 0) {
        result.push(subArray[subArray.length - 1]);
      }
    }
    return result;
  }

  const selectList = [
    {
      placeholder: t("home.filter.commission_rate"),
      onChange: (v) => {
        gaTracker.trackEvent("filter", true);
        setPage(1);
        setCommissionType(v);
        commissionTypeRef.current = v;
      },
      value: commissionType,
      opts: [
        {
          key: 1,
          label: '< 15%',
          checked: false,
        },
        {
          key: 2,
          label: '15% - 20%',
          checked: false,
        },
        {
          key: 3,
          label: '20% - 25%',
          checked: false,
        },
        {
          key: 4,
          label: '25% - 30%',
          checked: false,
        },
        {
          key: 5,
          label: '> 30%',
          checked: false,
        }
      ],
    },
    {
      placeholder: t("home.filter.earn_per_sale"),
      value: earnPerType,
      onChange: (v) => {
        gaTracker.trackEvent("filter", true);
        setEarnPerType(v);
        setPage(1);
        earnPerTypeRef.current = v;
      },
      opts: [
        {
          key: 1,
          label: `<${unit}3`,
          checked: false,
        },
        {
          key: 2,
          label: `${unit}3 - ${unit}5`,
          checked: false,
        },
        {
          key: 3,
          label: `${unit}5 - ${unit}10`,
          checked: false,
        },
        {
          key: 4,
          label: `${unit}10 - ${unit}20`,
          checked: false,
        },
        {
          key: 5,
          label: `>${unit}20`,
          checked: false,
        },
      ]
    },
    {
      placeholder: t("home.filter.top"),
      value: productTags,
      onChange: (v) => {
        gaTracker.trackEvent("filter", true);
        setProductTags(v);
        setPage(1);
        productTagsRef.current = v;
      },
      opts: [
        {
          key: 1,
          label: t("home.filter.top_selling"),
          checked: false,
        },
        {
          key: 2,
          label: t("home.filter.trending"),
          checked: false,
        },
      ]
    },
    {
      placeholder: t("home.filter.rating"),
      value: productRates,
      onChange: (v) => {
        gaTracker.trackEvent("filter", true);
        setProductRates(v);
        setPage(1);
        productRatesRef.current = v;
      },
      opts: [
        {
          key: 4,
          label: '>4.0',
          checked: false,
        },
        {
          key: 3,
          label: '3.0-4.0',
          checked: false,
        },
        {
          key: 2,
          label: '2.0-3.0',
          checked: false,
        },
        {
          key: 1,
          label: '<2.0',
          checked: false,
        }
      ]
    },
  ];

  const clear = () => {
    searchNameRef.current = "";
    searchNameTypeRef.current = 2;
    setCommissionType([]);
    setEarnPerType([]);
    setProductTags([]);
    setProductRates([]);
    commissionTypeRef.current = [];
    earnPerTypeRef.current = [];
    productRatesRef.current = [];
    productTagsRef.current = [];
    setSortType(-1);
    setSort(5);
    sortRef.current = 5;
    setCategory1Id(null);
    category1IdRef.current = null;
    setRandom(random + 1);
    setCategrayState(categrayState + 1);
    setFreeSample(false);
    freeSampleRef.current = 0;
  };

  const searchClear = () => {
    setCommissionType([]);
    setEarnPerType([]);
    setProductRates([]);
    setProductTags([]);
    commissionTypeRef.current = [];
    earnPerTypeRef.current = [];
    productRatesRef.current = [];
    productTagsRef.current = [];
    category1IdRef.current = null;
    setSortType(-1);
    setSort(5);
    sortRef.current = 5;
    setCategory1Id(null);
    setCategrayState(categrayState + 1);
    setFreeSample(false);
    freeSampleRef.current = 0;
  };

  const handleChangePage = () => {
    if (loadingRef.current === false) {
      setPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    getProdList();
    // }, [sort, page, category1Id, random, sortType, commissionType, earnPerType]);
  }, [sort, category1Id, random, sortType, commissionType, earnPerType, freeSample, needClickMore, productRates, productTags]);

  useEffect(() => {
    if (isGetList) {
      handleChangePage();
    }
  }, [isGetList]);
  useEffect(() => {
    // 使用 useEffect 监听 page 的变化
    setTimeout(() => {
      if (isGetList) {
        getProdList();
      }
    });
  }, [page]); // 只在 page 变化时执行

  useEffect(() => {
    if (userInfo && userInfo.needGuide) {
      setTimeout(() => {
        setOpen(true);
        APIGetGuideFinish({}).then(resp=>{
          getUserInfo();
        });
      }, 1000);
    }

    setSelectedTag(userInfo?.needSelectedTag ? true : false);

  }, [userInfo]);



  const onSortChange = (sortby, sortType, noClear = false) => {
    gaTracker.trackEvent(sortType === 5 ? "home_rec" : "sort", true);
    setSortType(sortType);
    if (sortby !== -1) {
      localStorage.setItem("mySort", `${sortby}`);
    }
    if (sortby === 5 && !noClear) {
      setRandom(random + 1);
      clear();
    }
    if (sort === sortby) {
      setSort(sort);
      sortRef.current = sortby;
      setPage(1); // Reset page when sorting
      pageRef = 1;
      setHasMore(true); // 重置是否还有更多数据
    } else {
      setSort(sortby);
      sortRef.current = sortby;
      setPage(1); // Reset page when sorting
      pageRef = 1;
      setHasMore(true); // 重置是否还有更多数据
    }
  };

  const handleScroll = () => {
    const nearBottom = window.innerHeight + document.documentElement.scrollTop >= scrollDiv.current?.offsetHeight - 200;
    if (nearBottom && !isGetList) {
      // pageRef = page + 1;
      // setPage(page + 1);
      setIsGetList(true); // 设置为已请求
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [loading, pageLoading]);

  const onSearch = (v, searchType, sortNum) => {
    gaTracker.trackEvent("search", true);
    setPage(1);
    pageRef = 1;
    searchNameRef.current = v;
    searchNameTypeRef.current = searchType;
    if (sortNum){
      sortRef.current = sortNum;
      setSort(sortNum);
    }
    if (v === '') {
      clear();
      getProdList("", 2, false);
    } else {
      if (!sortNum) {
        if ( sort !== 5 || commissionType || earnPerType || category1Id) {
          searchClear();
        }
      }
      getProdList(v, searchType, false);
    }
    if (!v) return;
    const item = { name: v, type: searchType };
    let localHistory = localStorage.getItem("history");
    if (localHistory) {
      localHistory = JSON.parse(localHistory);
    } else {
      localHistory = [];
    }
    if (localHistory && localHistory.filter(it => it.name === item.name && Number(it.type) === Number(item.type)).length === 0) {
      localHistory.unshift(item);
    }

    localHistory = localHistory.length > 5 ? localHistory.slice(0, 5) : localHistory;
    localStorage.setItem("history", JSON.stringify(localHistory));
  };

  const onCheckLevel1 = useCallback(
    debounce((v) => {
      gaTracker.trackEvent("filter", true);
      pageRef = 1;
      setPage(1);
      if (v === category1IdRef.current) {
        setCategory1Id(null);
        category1IdRef.current = null;
        return;
      }
      setCategory1Id(v);
      category1IdRef.current = v;
    }, 300),
    []
  );

  const breakpointColumnsObj = {
    default: 5, // 默认列数
    1920: 5,  // 屏幕宽度 >= 1440px 时为 5 列
    1600: 5, // 屏幕宽度 >= 1440px 时为 4 列
    1200: 3, // 屏幕宽度 >= 1100px 时为 3 列
  };

  const items = useMemo(() => {
    return prodList && prodList.map((item, index) => {

      if (index === 0) {
        return <div ref={stepRef2} key={`key_${item.productId}_${index}`}>
          <ProductCard key={item.productId} item={item}></ProductCard>
        </div>;
      }

      return <div key={`key_${item.productId}_${index}`}>
        <ProductCard key={item.productId} item={item}></ProductCard>
      </div>;


    });
  }, [prodList]);

  useEffect(() => {
    const element = document.getElementById("home_search_bar");
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          eventSub.publish(EventName.HomeSearchShow);
        } else {
          eventSub.publish(EventName.HomeSearchUnShow);
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div style={{
      width: "100vw",
      minHeight: "500px"
    }}>
      <div onClick={() => {
        setCurrentExt("");
      }} onFocus={() => setVisibleDropDown(false)} ref={scrollDiv} className={styles.home_page}>
        <div className={"relative w-full my-3 flex items-start"}>
          <div className={"flex-1 max-w-[calc(100%-380px)]"}>
            {
              bannerList && bannerList.length > 0 ? <Carousel autoplay={true} autoplaySpeed={3000}  arrows={bannerList.length > 1} contentClassName={"h-full"} dots={bannerList.length > 1} className={"w-full !h-[320px] rounded-xl overflow-hidden"}>
                {
                  bannerList.map((item, index) => {
                    return <div onClick={()=>{
                      if (item?.sectionId){
                        router.push(`/hotsale/${item?.sectionId}?utm_source=homepage`);
                      }
                      APIGetHomeBannerClick(item?.id).then();
                      // if (item?.linkUrl){
                      //   window.open(item?.linkUrl, "_blank");
                      // } else {
                      //   router.push(`/hotsale/${item?.sectionId}?utm_source=homepage`);
                      // }
                    }} key={`img${index}`} className={"cursor-pointer w-full !h-[320px] rounded-xl"} >
                      <img alt={"banner"} src={item?.imageUrl} className={"!w-full !h-[320px] rounded-xl !object-cover"} />
                      {/* <AppImage className={"!w-full !h-[310px] rounded-xl !object-cover"} src={item?.imageUrl}></AppImage>*/}
                    </div>;
                  })
                }
              </Carousel> : <Skeleton className={"flex-1 !h-[320px] rounded-xl"}></Skeleton>
            }
          </div>
          <div className={"w-[20px]"}></div>
          <HotProductWrap></HotProductWrap>
        </div>
        <div ref={stepRef1}>
          <div className={styles.mobile_wrap}>
            <div id={"home_search_bar"} className={"flex items-center just-center"}>
              <SearchBar state={random} searchNameRef={searchNameRef.current} searchNameTypeRef={searchNameTypeRef.current} loading={loading} onChange={onSearch} />
            </div>
            {
              loaded ? <div className={styles.select_area}>
                <div className={styles.select_area_item}>
                  <CategoryTreeSelect state={categrayState} categor2y1Id={category1Id} className={styles.select_category} onCategoryChange={onCheckLevel1}>

                  </CategoryTreeSelect>
                  {
                    selectList.map(item => {
                      return <div className={"flex-1"} key={item.placeholder}>
                        <SelectComp value={item.value} onChange={item.onChange} placeholder={item.placeholder} opts={item.opts}></SelectComp>
                      </div>;
                    })
                  }
                </div>
              </div> : <div>
                <div className={"flex items-center justify-between"}>
                  <Skeleton className={"w-[200px] h-[40px] rounded-lg"}></Skeleton>
                  <Skeleton className={"w-[200px] h-[40px] rounded-lg"}></Skeleton>
                  <Skeleton className={"w-[200px] h-[40px] rounded-lg"}></Skeleton>
                </div>
                </div>
            }
          </div>
          <div className={`${styles.sort_wrap} flex items-center`}>
            <Image className={"w-4 h-4 cursor-pointer mr-1 shrink-0"} src={"/images/filter-icon.svg"} alt={""} width={10} height={10}></Image>
            <div className={"text-sm text-[#A7A7A7] shrink-0 mr-[20px]"}>{t('condition_h5.sort_by')}</div>
            <SortBy freeSample={freeSample} onChangeFreeSample={(free)=>{
              setFreeSample(free);
              freeSampleRef.current = free ? 1 : 0;
            }} current={sort} sortType={sortType} onChange={onSortChange} />
          </div>
        </div>

        <Spin style={{
          width: "100%",
        }} spinning={pageLoading} indicator={<CommonLoading />} >
          {
            prodList.length === 0 && !pageLoading && <CustomEmpty showRec={false} showResult={false} result={`Sorry，there are no results for ${searchNameRef.current ? `"${searchNameRef.current}"` : "unknown"}`} />
          }
          <Masonry
            breakpointCols={breakpointColumnsObj} // 响应式列数配置
            className={"my_masonry_grid"} // 容器类名
            columnClassName={"my_masonry_grid_column"} // 列的类名
          >
            {
              items
            }
          </Masonry>

          {

            needClickMore && <div onClick={() => {
              setIsGetList(false);
              setNeedClickMore(false);
            }} className={"text-center trans-all hover:opacity-80 text-[14px] text-white rounded-[20px] flex items-center justify-center bg-color2 mx-auto w-[214px] h-[40px] font-bold cursor-pointer"}>
              See More <Image className={"ml-1"} width={14} height={8} src={"/images/see-more-right-icon.svg"} alt={""}></Image>
            </div>

          }

          {
            (!pageLoading && prodList.length > 0 && loadingMore) ? <div className={"flex items-center justify-center"}>

              <CommonLoading className={"w-[30px] h-[30px]"}></CommonLoading>
            </div> : <div className={"h-[30px]"}>

            </div>
          }
          <SizeBox h={40}></SizeBox>
        </Spin>
      </div>

      <CategorySelectModal onSelected={[]} visible={!open && selectedTag} onCancel={()=>setSelectedTag(false)}></CategorySelectModal>

      <Tour disabledInteraction={true} closeIcon={false} open={open} current={currentStep} scrollIntoViewOptions={false} onClose={() => setOpen(false)} arrow={false} steps={steps} />
    </div>
  );
};

export default Home;
